import { Card, Flex, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useOrganization } from '../../api/Onboarding';
import BackButton from '../../components/BackButton';
import Loading from '../../components/Loading';
import ChartConfiguration from './ChartConfiguration';
import OrganizationSettings from './OrganizationSettings';

const { Title } = Typography;

const StyledDiv = styled.div`
  padding: 0 24px 24px;
`;

function AccountSettings() {
  const navigate = useNavigate();
  const { data: organization, isLoading: organizationLoading } = useOrganization();

  if (organizationLoading) {
    return <Loading />;
  }

  return (
    <StyledDiv>
      <BackButton onClick={() => navigate(-1)} text="Back" />
      <Flex vertical gap={16}>
        <Title level={4}>Account settings</Title>

        <Card title={<>Organization settings</>}>
          <OrganizationSettings organization={organization.data} />
        </Card>

        <Card title="Chart configuration">
          <ChartConfiguration organizationId={organization.data.id} />
        </Card>
      </Flex>
    </StyledDiv>
  );
}

export default AccountSettings;
